/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ApiAttachmentSortKind {
  FileName = 'fileName',
  CreatedAt = 'createdAt',
  FileSizeBytes = 'fileSizeBytes',
  TransactionTitle = 'transactionTitle',
  UploadedBy = 'uploadedBy'
}
